var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.65377 3.66563V5.38312H4.39502V7.48312H5.65377V13.7244H8.23752V7.48375H9.97189C9.97189 7.48375 10.1344 6.47687 10.2131 5.37562H8.24814V3.93937C8.24814 3.725 8.52939 3.43625 8.80814 3.43625H10.2169V1.25H8.30189C5.58939 1.25 5.65377 3.35188 5.65377 3.66563Z",
    fill: "#22AD01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookGreen);
export default __webpack_public_path__ + "static/media/facebook-green.cf9fc36815e3081a0c5a37e7a8673173.svg";
export { ForwardRef as ReactComponent };